import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'
import { FONT_SIZE_CLASS_GROUP } from './text-scale.ts'

/**
 * Merges class names, letting a later conflicting utility win.
 *
 * `cn('px-control-x-sm', 'px-control-x-md')` → `'px-control-x-md'`. Without twMerge both
 * survive and the winner depends on CSS source order, which is not something a component
 * author can reason about.
 *
 * The `font-size` group MUST list our scale — see text-scale.ts for why, and for the test that
 * keeps it in step with theme.css.
 */
const merge = extendTailwindMerge({
  extend: { classGroups: FONT_SIZE_CLASS_GROUP },
})

export const cn = (...inputs: ClassValue[]): string => merge(clsx(inputs))
